import React from "react";
import "./trendings.css";

function trendingSection() {
  return (
    <div className="trending-section">
      <div className="container">
        <div className="row">

          {/* Column 1 */}
          <div className="col-md-12 col-lg-3 mb-5 mb-lg-0">
            <h2 className="mb-4 section-title">
              Trend <br />Crafted with excellent material.
            </h2>
            <p className="mb-5">
              Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit.
            </p>
            <button className="btn btn-primary explore-btn">
  Explore
</button>
          </div>

          {/* Column 2 */}
          <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
            <a className="trending-item" href="/trending">
              <img src="/images/trending-1.png" className="img-fluid trending-thumbnail" alt="trending" />
              <h3 className="trending-title">Nordic Chair</h3>
              

              <span className="icon-cross">
                <img src="/images/cross.svg" className="img-fluid" alt="icon" />
              </span>
            </a>
          </div>

          {/* Column 3 */}
          <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
            <a className="trending-item" href="/cart">
              <img src="/images/trending-2.png" className="img-fluid trending-thumbnail" alt="trending" />
              <h3 className="trending-title">Kruzo Aero Chair</h3>
              

              <span className="icon-cross">
                <img src="/images/cross.svg" className="img-fluid" alt="icon" />
              </span>
            </a>
          </div>

          {/* Column 4 */}
          <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
            <a className="trending-item" href="/cart">
              <img src="/images/trending-3.png" className="img-fluid trending-thumbnail" alt="trending" />
              <h3 className="trending-title">Ergonomic Chair</h3>
              

              <span className="icon-cross">
                <img src="/images/cross.svg" className="img-fluid" alt="icon" />
              </span>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
}

export default trendingSection;